<div class="iptv-dialog">
  <div class="iptv-dialog__header iptv-dialog__header--tabs">
    <!-- HEADER CONTENT -->
    <div mat-dialog-title >
      <div class="iptv-dialog__title">
        <ng-content select="[iptv-dialog__title]"></ng-content>
      </div>
      <ng-content select="[iptv-dialog__options]"></ng-content>
    </div>
  </div>

  <div class="app-loading-anchor">
    <app-loading-indicator [loading]="loading"></app-loading-indicator>
  </div>
  <div  mat-dialog-content>
    <!-- DIALOG CONTENT -->
    <div class="iptv-dialog__content" *ngIf="!loading">
      <ng-content select="[iptv-dialog__content]"></ng-content>
    </div>
  </div>

  <div
    mat-dialog-actions
    align="end"
    class="dialog-buttons content-playlist-dialog__footer"
  >
    <!-- ACTIONS CONTENT -->
    <div>
      <button
        mat-stroked-button
        color="basic"
        (click)="closeDialog()"
        data-testId="close-dialog-button"
        class="action-buttons"
      >
      <b>CLOSE</b>
      </button>
    </div>

    <div class="iptv-dialog__actions">
      <ng-content select="[iptv-dialog__actions]"></ng-content>
    </div>
  </div>
</div>
